"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserLookupType = void 0;
var UserLookupType;
(function (UserLookupType) {
    UserLookupType[UserLookupType["None"] = 0] = "None";
    UserLookupType[UserLookupType["Retail"] = 1] = "Retail";
    UserLookupType[UserLookupType["Business"] = 2] = "Business";
})(UserLookupType = exports.UserLookupType || (exports.UserLookupType = {}));
